import { ChangeDetectorRef, Component, OnDestroy } from '@angular/core';
import { TranslateService } from '@shared/translate/translate.service';
import { ProductFilterStateManagerService } from '@products/fund-listing/services/product-filter-state-manager.service';
import { FiltersState, ToggleOption } from '@types';

@Component({
  selector: 'ft-ratings-group-header',
  templateUrl: './ratings-group-header.component.html',
  styleUrls: ['./ratings-group-header.component.scss'],
})
export class RatingsGroupHeaderComponent implements OnDestroy {
  private selectedValue = '';
  tooltip: string;
  placement: string;
  ratingsTypeToggle: ToggleOption[] = [
    {
      text: this.translateService.instant('products.ratings-all'),
      active: true,
      value: '',
    },
    {
      text: this.translateService.instant('products.ratings-3starplus'),
      active: false,
      value: '3',
    },
    {
      text: this.translateService.instant('products.ratings-4starplus'),
      active: false,
      value: '4',
    },
    {
      text: this.translateService.instant('products.ratings-5star'),
      active: false,
      value: '5',
    },
  ];
  asOfDateText: string;

  constructor(
    private cdr: ChangeDetectorRef,
    private translateService: TranslateService,
    private filterStateManagerService: ProductFilterStateManagerService
  ) {}

  agInit(params: any) {
    this.tooltip = this.translateService.tooltip('products.ratings-title');
    this.asOfDateText = `${this.translateService.instant('products.as-of')} ${
      params.ratingsAsOfDate
    } ${
      !params.isSiteIntl
        ? this.translateService.instant(
            'products.ratings-risk-adjusted-returns'
          )
        : ''
    }`;
    this.placement = 'PPSS:MorningStarRatingPPSS';

    this.filterStateManagerService.subscribe((state: FiltersState) => {
      if (state.morningStarFilter.selected.length) {
        this.selectedValue = state.morningStarFilter.selected[0];
      } else {
        this.selectedValue = '';
      }
      this.setActive();
      this.cdr.detectChanges();
    });
  }

  private setActive() {
    this.ratingsTypeToggle.forEach((toggleOption) => {
      if (toggleOption.value === this.selectedValue) {
        toggleOption.active = true;
      } else {
        toggleOption.active = false;
      }
    });
  }

  /**
   * Update the ratings view as per rating selected.
   */
  onUpdate(selectedToggleOption: ToggleOption) {
    this.filterStateManagerService.filterByMorningstarRating(
      selectedToggleOption.value
    );
  }

  ngOnDestroy(): void {
    this.filterStateManagerService?.unsubscribe();
  }
}
